'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COLORS = exports.BLACK = exports.WHITE = exports.PALE_BLUE = exports.GREY = exports.RED = exports.OFF_WHITE = exports.CHARCOAL = exports.ORANGE = exports.GREEN = exports.BLUE = undefined;

var _upperFirst2 = require('lodash/upperFirst');

var _upperFirst3 = _interopRequireDefault(_upperFirst2);

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.text = text;
exports.background = background;
exports.border = border;
exports.hoverColor = hoverColor;
exports.dropshadowColor = dropshadowColor;

var _chromaJs = require('chroma-js');

var _chromaJs2 = _interopRequireDefault(_chromaJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BLUE = exports.BLUE = '#3FAFD7';
var GREEN = exports.GREEN = '#99c63b';
var ORANGE = exports.ORANGE = '#ffa856';
var CHARCOAL = exports.CHARCOAL = '#59636f';
var OFF_WHITE = exports.OFF_WHITE = '#f1f1f1';
var RED = exports.RED = '#cf2a27';
var GREY = exports.GREY = '#555';
var PALE_BLUE = exports.PALE_BLUE = '#96a7bb';
var WHITE = exports.WHITE = '#FFF';
var BLACK = exports.BLACK = '#000';

var COLORS = exports.COLORS = {
  BLUE: BLUE,
  GREEN: GREEN,
  ORANGE: ORANGE,
  CHARCOAL: CHARCOAL,
  OFF_WHITE: OFF_WHITE,
  RED: RED,
  GREY: GREY,
  PALE_BLUE: PALE_BLUE,
  WHITE: WHITE,
  BLACK: BLACK
};

function text(color) {
  return { color: color };
}

function background(color) {
  return { backgroundColor: color };
}

function border(color) {
  var optional = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var entries = Object.entries(_extends({
    top: color,
    right: color,
    bottom: color,
    left: color
  }, optional));
  return entries.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        direction = _ref2[0],
        value = _ref2[1];

    return [(0, _upperFirst3.default)(direction), value];
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        direction = _ref4[0],
        value = _ref4[1];

    return _defineProperty({}, 'border' + direction + 'Color', value);
  }).reduce(function (a, c) {
    return _extends({}, a, c);
  }, {});
}

function hoverColor(color) {
  return (0, _chromaJs2.default)(color).brighten(0.3).css('hsl');
}

function dropshadowColor(color) {
  return (0, _chromaJs2.default)(color).darken(0.25).css('hsl');
}

exports.default = {};


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/styles/colors.js
// module id = 26
// module chunks = 0